import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Subscriptions() {
  const { t } = useLang();
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    let cancelled = false;
    api
      .get("/subscriptions")
      .then(({ data }) => { if (!cancelled) setSubs(data); })
      .catch((error) => { console.error("Failed to load subscriptions:", error); });
    return () => { cancelled = true; };
  }, []);
  return (
    <DashboardLayout title={t("subs.title")} subtitle={t("subs.subtitle")}>
      <div className="rounded-xl border border-zinc-800 overflow-hidden" data-testid="subs-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-zinc-500 border-b border-zinc-800 bg-zinc-900/40">
              <th className="p-3">Plan</th>
              <th className="p-3">Tenant</th>
              <th className="p-3">{t("common.status")}</th>
              <th className="p-3">Since</th>
            </tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.subscription_id || s.stripe_subscription_id || `${s.tenant_id}-${s.lookup_key}`} className="border-b border-zinc-800 hover:bg-zinc-900/40">
                <td className="p-3 text-zinc-100">{s.lookup_key}</td>
                <td className="p-3 text-zinc-500 text-xs">{s.tenant_id?.slice(-8) || "—"}</td>
                <td className="p-3">
                  <span className="inline-flex items-center gap-2 text-xs">
                    <span className={`w-2 h-2 rounded-full ${s.status === "active" ? "bg-emerald-500 glow-green" : "bg-zinc-500"}`} />
                    {s.status}
                  </span>
                </td>
                <td className="p-3 text-zinc-500 text-xs">{s.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
            {subs.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-zinc-500">{t("common.no_data")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
